export const transformOption = (value: { id: string | number; name: string }) => ({
  value: `${value.id}`,
  label: value.name,
});
